module.exports = __webpack_public_path__ + "img/battery-half.14df5ef8.svg";